import React from "react";

import { useState } from "react";

import Button from "../../Components/forms/Button";
import Input from "../../Components/forms/Input";
import TipInput from "../../Components/forms/TipInput";

import styles from "./VitrineTelasComprovantes.module.css";
import LogoVitrine from "../../assets/ic_file_red.svg";

import { VITRINE_TELAS_COMPROVANTES } from "../../api";
import { checkPermissions } from "../../utils/standaloneUtils";
import { UserContext } from "../../UserContext";

const VitrineTelasComprovantes = () => {
  const [screenName, setscreenName] = React.useState("");
  const [produto, setProduto] = React.useState("");
  const [produtoCalendario, setProdutoCalendario] = React.useState("");
  const [subProduto, setSubProduto] = React.useState("");
  const [subProdutoCalendario, setSubProdutoCalendario] = React.useState("");
  const [tipoConversao, setTipoConversao] = React.useState("");
  const [t, setT] = React.useState("s");

  const [showForm, setShowForm] = React.useState(false);
  const [showBtSave, setShowBtSave] = React.useState(false);
  const [showBtUpdate, setShowBtUpdate] = React.useState(false);

  const [uuid, setUuid] = React.useState("");
  const { data, permission, modules } = React.useContext(UserContext);

  //const imgExemple = require("../assets/logo.png");

  const initialData = [
    {
      produto: "Carregando...",
      produtoCalendario: "Carregando...",
      screenName: "Carregando...",
      subproduto: "Carregando...",
      subprodutoCalendario: "Carregando...",
      tipoConversao: "Carregando...",
      uuid: "Carregando...",
    },
  ];

  const [allData, setAllData] = React.useState(initialData);

  React.useEffect(() => {
    const { url: urlNotification, options: optionsNotification } =
      VITRINE_TELAS_COMPROVANTES({
        screenName: "vazio",
        produto: "vazio",
        produtoCalendario: "vazio",
        subproduto: "vazio",
        subprodutoCalendario: "vazio",
        tipoConversao: "vazio",
        t: "s", // "i" ou "s"
      });
    fetch(urlNotification, optionsNotification)
      .then((response) => response.json())
      .then((data) => {
        showAllItems(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  function showAllItems(allItems) {
    setAllData(allItems);
  }

  function handleUpdateBQ() {
    const { url: urlNotification, options: optionsNotification } =
      VITRINE_TELAS_COMPROVANTES({
        screenName: screenName,
        produto: produto,
        produtoCalendario: produtoCalendario,
        subproduto: subProduto,
        subprodutoCalendario: subProdutoCalendario,
        tipoConversao: tipoConversao,
        uuidParam: uuid,
        t: "u", // "i" ou "s" ou "u"
      });
    fetch(urlNotification, optionsNotification)
      .then((response) => response.json())
      .then((data) => {
        showAllItems(data);
        setShowForm(false);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function handleEditData() {
    setscreenName(
      event.target.parentNode.parentNode.parentNode.getElementsByTagName(
        "td"
      )[0].innerHTML
    );
    setProduto(
      event.target.parentNode.parentNode.parentNode.getElementsByTagName(
        "td"
      )[1].innerHTML
    );
    setProdutoCalendario(
      event.target.parentNode.parentNode.parentNode.getElementsByTagName(
        "td"
      )[2].innerHTML
    );
    setSubProduto(
      event.target.parentNode.parentNode.parentNode.getElementsByTagName(
        "td"
      )[3].innerHTML
    );
    setSubProdutoCalendario(
      event.target.parentNode.parentNode.parentNode.getElementsByTagName(
        "td"
      )[4].innerHTML
    );
    setTipoConversao(
      event.target.parentNode.parentNode.parentNode.getElementsByTagName(
        "td"
      )[5].innerHTML
    );
    setUuid(
      event.target.parentNode.parentNode.parentNode
        .getElementsByTagName("td")[6]
        .getElementsByTagName("span")[0].innerHTML
    );
  }

  function handleAddBQ() {
    setscreenName("");
    setProduto("");
    setProdutoCalendario("");
    setSubProduto("");
    setSubProdutoCalendario("");
    setTipoConversao("");

    const { url: urlNotification, options: optionsNotification } =
      VITRINE_TELAS_COMPROVANTES({
        screenName: screenName,
        produto: produto,
        produtoCalendario: produtoCalendario,
        subproduto: subProduto,
        subprodutoCalendario: subProdutoCalendario,
        tipoConversao: tipoConversao,
        uuidParam: "vazio",
        t: "i", // "i" ou "s" ou "u"
      });
    fetch(urlNotification, optionsNotification)
      .then((response) => response.json())
      .then((data) => {
        showAllItems(data);
        setShowForm(false);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  const upperButtons = () => {
    if (checkPermissions('vitrine', modules, permission) > 2)
      return (
        <div className={styles.buttonAction}>
          <button className={styles.vitrineButton}>Editar</button>
          <button className={styles.vitrineButton}>Excluir</button>
          <button
            className={styles.addButton}
            onClick={function (event) {
              setShowForm(true);
              setShowBtSave(true);
              setShowBtUpdate(false);
            }}
          >
            Adicionar
          </button>
        </div>
      )
  }


  return (
    <main className="container">
      <div className="container-page">
        <section className={`${styles.sectionWebPush} container`}>
          <h1 className={styles.titlePageWebPush}></h1>
          <div className="title-page">
            <img src={LogoVitrine} className={styles.iconVitrine} />
            <h1> Vitrine - Telas de comprovantes </h1>
            {upperButtons()}
          </div>
          <div className={styles.containerPageWebPush}>
            {showForm && (
              <div className={styles.formsPageWebPush}>
                <Input
                  value={screenName}
                  onChange={(e) => setscreenName(e.target.value)}
                  placeholder={"Nome da tela"}
                  type={"text"}
                />
                <Input
                  value={produto}
                  onChange={(e) => setProduto(e.target.value)}
                  placeholder={"Nome do produto"}
                  type={"text"}
                />
                <Input
                  value={produtoCalendario}
                  onChange={(e) => setProdutoCalendario(e.target.value)}
                  placeholder={"Calendário do produto"}
                  type={"text"}
                />
                <Input
                  value={subProduto}
                  onChange={(e) => setSubProduto(e.target.value)}
                  placeholder={"Sub produto"}
                  type={"text"}
                />
                <Input
                  value={subProdutoCalendario}
                  onChange={(e) => setSubProdutoCalendario(e.target.value)}
                  placeholder={"Sub produto calendário"}
                  type={"text"}
                />
                <Input
                  value={tipoConversao}
                  onChange={(e) => setTipoConversao(e.target.value)}
                  placeholder={"Tipo da conversão"}
                  type={"text"}
                />
                {showBtSave && (
                  <Button
                    className={styles.btnSendWebPush}
                    onClick={handleAddBQ}
                  >
                    Salvar
                  </Button>
                )}

                {showBtUpdate && (
                  <Button
                    className={styles.btnSendWebPush}
                    onClick={handleUpdateBQ}
                  >
                    Atualizar
                  </Button>
                )}
              </div>
            )}
            {showForm && (
              <div className={styles.containerPreviewPageWebPush}>
                <h2>Preview:</h2>
                <div className={styles.containerPreviewPageWebPushExternal}>
                  <div className={styles.cardPreviewWebPush}>
                    <table>
                      <thead>
                        <tr>
                          <th>Nome da tela</th>
                          <th>Nome do produto</th>
                          <th>Calendário do produto</th>
                          <th>Sub produto</th>
                          <th>Sub produto calendário</th>
                          <th>Tipo da conversão</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{screenName}</td>
                          <td>{produto}</td>
                          <td>{produtoCalendario}</td>
                          <td>{subProduto}</td>
                          <td>{subProdutoCalendario}</td>
                          <td>{tipoConversao}</td>
                        </tr>
                      </tbody>
                    </table>

                    {/* <div className={styles.containerTextPreview}>
              <div className={styles.containerTitleClosedPreview}>
                <h3 className={styles.titlePreview}>
                  {title ? title : "Titulo"}
                </h3>
                <span className={styles.containerClose}>&#x2715;</span>
              </div>
              <p className={styles.descritionPreview}>
                {body ? body : "Descrição"}
              </p>
              <p className={styles.linkPreview}>
                {urlValue ? urlValue : "https://www.santander.com.br"}
              </p>
            </div> */}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className={styles.tabela}>
            <table>
              <thead>
                <tr>
                  <th>ScreenName</th>
                  <th>Produto</th>
                  <th>Produto Calendário</th>
                  <th>Subproduto</th>
                  <th>Subproduto Calendário</th>
                  <th>Tipo Conversão</th>
                  {/* <th>Editar</th>
                  <th>Excluir</th> */}
                </tr>
              </thead>
              <tbody>
                {allData.map((dataItem) => (
                  <tr>
                    <td>{dataItem.screenName}</td>

                    <td>{dataItem.produto}</td>

                    <td>{dataItem.produtoCalendario}</td>

                    <td>{dataItem.subproduto}</td>

                    <td>{dataItem.subprodutoCalendario}</td>

                    <td>{dataItem.tipoConversao}</td>

                    {/* <td>
                      {" "}
                      <a
                        className={styles.icEdit}
                        onClick={function (event) {
                          setShowForm(true);
                          setShowBtUpdate(true);
                          setShowBtSave(false);
                          handleEditData();
                        }}
                      >
                        <img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaWQ9IkxheWVyXzEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDEyOCAxMjg7IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxMjggMTI4IiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiMzMUFGOTE7fQoJLnN0MXtmaWxsOiNGRkZGRkY7fQo8L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjY0IiBjeT0iNjQiIHI9IjY0Ii8+PGc+PHBhdGggY2xhc3M9InN0MSIgZD0iTTg3LjQsNTAuNWw5LjktOS45YzAuNC0wLjQsMC40LTEsMC0xLjRsLTguNS04LjVjLTAuNC0wLjQtMS0wLjQtMS40LDBsLTkuOSw5LjlMODcuNCw1MC41eiIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik03NC42LDQzLjVMMzgsODAuMWwtNC40LDEzYy0wLjMsMC44LDAuNSwxLjUsMS4zLDEuM2wxMy00LjRsMzYuNi0zNi42TDc0LjYsNDMuNXoiLz48L2c+PC9zdmc+" />
                      </a>{" "}
                      <span>{dataItem.uuid}</span>
                    </td>
                    <td>
                      {" "}
                      <a className={styles.icDelete}>
                        <img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaWQ9IkxheWVyXzEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDYxMiA3OTI7IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA2MTIgNzkyIiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiNFNDQwNjE7fQo8L3N0eWxlPjxnPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik01NjIsMzk2YzAtMTQxLjQtMTE0LjYtMjU2LTI1Ni0yNTZTNTAsMjU0LjYsNTAsMzk2czExNC42LDI1NiwyNTYsMjU2UzU2Miw1MzcuNCw1NjIsMzk2TDU2MiwzOTZ6IE0zNTYuOCwzOTYgICBMNDc1LDUxNC4yTDQyNC4yLDU2NUwzMDYsNDQ2LjhMMTg3LjgsNTY1TDEzNyw1MTQuMkwyNTUuMiwzOTZMMTM3LDI3Ny44bDUwLjgtNTAuOEwzMDYsMzQ1LjJMNDI0LjIsMjI3bDUwLjgsNTAuOEwzNTYuOCwzOTYgICBMMzU2LjgsMzk2eiIvPjwvZz48L3N2Zz4=" />
                      </a>{" "}
                      <span>{dataItem.uuid}</span>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
        <div className={styles.paginas}>
          <p>Itens por página:</p>
          <ul className={styles.pagination}>
            <li>
              <a href="#">«</a>
            </li>
            <li>
              <a href="#">1</a>
            </li>
            <li>
              <a className="active" href="#">
                2
              </a>
            </li>
            <li>
              <a href="#">3</a>
            </li>
            <li>
              <a href="#">4</a>
            </li>
            <li>
              <a href="#">5</a>
            </li>
            <li>
              <a href="#">6</a>
            </li>
            <li>
              <a href="#">7</a>
            </li>
            <li>
              <a href="#">»</a>
            </li>
          </ul>
        </div>
      </div>
    </main>
  );
};

export default VitrineTelasComprovantes;
